<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card" v-if="project">
                        <div class="card-header d-flex justify-content-between">
                            <h5 class="mb-0"><b>Tratte</b></h5>
                            <p class="mb-0"><strong>Missione:</strong> {{ project.project_name }}</p>
                        </div>
                        <div class="card-body p-0" v-if="project">
                            <template v-if="project.tasks.length">
                                <div class="table-responsive">
                                    <table class="table center-aligned-table mb-0">
                                        <thead>
                                            <tr>
                                                <th class="priority-3 border-bottom-0 text-center">Stato</th>
                                                <th class="border-bottom-0">Progress</th>
                                                <!-- <th class="border-bottom-0">ID</th> -->
                                                <th class="border-bottom-0">Tratta</th>
                                                <!-- <th class="border-bottom-0 text-center">Tipo</th> -->
                                                <!-- <th class="border-bottom-0">Meta</th> -->
                                                <th class="priority-3 border-bottom-0">Assegnata a</th>
                                                <th class="border-bottom-0">Data tratta</th>
                                                <!-- <th class="border-bottom-0">Data compilazione</th> -->
                                                <th class="priority-3 border-bottom-0 text-center">NC</th>
                                                <th class="priority-3 border-bottom-0 text-center"></th>
                                                <th class="border-bottom-0"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tasks-table-row
                                                v-for="task in project.tasks"
                                                :key="task.id"
                                                :task="task"
                                                @delete="deleteTask"
                                                @change-status="toggleStatus"
                                                @edit="editTask"
                                            />
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                            <template v-else>
                                <div class="alert alert-info mb-0">
                                    Non esistono tratte per questa missione.
                                </div>
                            </template>
                        </div>
                        <div class="card-footer d-flex bd-highlight">
                            <button type="button" class="btn btn-primary" @click="$router.go(-1)">
                                <font-awesome-icon icon="angle-left"></font-awesome-icon>&nbsp;INDIETRO
                            </button>
                            <!-- <button class="btn btn-success ml-auto bd-highlight" @click="addTask">
                                <font-awesome-icon icon="plus" size="sm" />&nbsp;AGGIUNGI TRATTA
                            </button> -->
                        </div>
                    </div>
                    <div v-else class="alert alert-info">
                        Missione non trovata.
                    </div>
                </div>
            </div>
        </div>
        <task-modal
            v-if="project"
            :task="currentTask"
            :project="project"
        />
    </section>
</template>

<script>
/* eslint-disable no-unused-vars */
import {
    Task
} from '@/models/Task'
import {
    mapGetters
} from 'vuex'
import {
    GET_SINGLE,
    UPDATE,
    DELETE
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/projects.module'
import {
    MODULE_NAME as TASKS_MODULE_NAME
} from '@/store/modules/tasks.module'
export default {
    name: 'project-detail',
    data () {
        return {
            currentTask: new Task()
        }
    },
    computed: {
        ...mapGetters([
            'currentUser',
            'isAuthenticated',
        ]),
        ...mapGetters({
            project: `${MODULE_NAME}/getSingle`
        })
    },
    mounted () {
        this.fetchProject()
    },
    methods: {
        fetchProject () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_SINGLE}`, {
                id: this.$route.params.id
            })
        },
        addTask () {
            this.currentTask = new Task()
            this.$modal.show('task-modal')
        },
        editTask (task) {
            this.currentTask = new Task(task)
            this.$modal.show('task-modal')
        },
        deleteTask (task) {
            this.$swal({
                title: 'Sei sicuro?',
                text: 'Una volta eliminata non potrai più recuperare questa tratta!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No, annulla.',
                confirmButtonText: 'Si, eliminala!'
            }).then((willDelete) => {
                if (willDelete.value) {
                    this.$store.dispatch(`${TASKS_MODULE_NAME}/${DELETE}`, task.id).then(() => {
                        this.fetchProject()
                        this.$swal({
                            title: 'Ok!',
                            text: 'Tratta eliminata correttamente.',
                            type: 'success'
                        })
                    })
                } else {
                    this.$swal('Ok!', 'Tratta non eliminata!')
                }
            })
        },
        toggleStatus (task) {
            // 'Clono' il task;
            let _temp = new Task(task)
            // Cambio status al task (0 / 1)
            // ATTENZIONE: Per gestire più di 2 stati valutare l'opzione di fare '+1' ad ogni click
            _temp.task_status = !task.task_status
            this.$store.dispatch(`${TASKS_MODULE_NAME}/${UPDATE}`, _temp).then((r) => {
                if (r.status === 200) {
                    task.task_status = r.data.task_status
                }
            })
        }
    },
    components: {
        tasksTableRow: () => import('@/views/tasks/components/TasksTableRow'),
        TaskModal: () => import('@/views/tasks/TaskModal')
    }
}
</script>
